import { colors } from '@chegg-ui/theme'
import styled from 'styled-components'
import { SpecialButtonLink } from '@chegg-wt/core/theme/fanta/button'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import { Heading1, Heading3, Body } from '@chegg-wt/core/theme/sunkist/typography'

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

export const AccountContainer = styled.main`
  ${AspiraStack};
  background-color: ${({ theme }) => theme.Colors.bottomContent};
  border-radius: 3px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${values.large} ${values.xlarge};
  text-align: center;
  flex: 1;
`

export const AccountHeader = styled.h1`
  ${Heading1};
  text-align: center;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor14};
`

export const LoginMessage = styled.p`
  ${AspiraStack};
  text-align: center;
  padding-top: ${values.large};
`

export const AuthLink = styled.a`
  color: ${colors.link};
  cursor: pointer;
`

export const Notice = styled.p`
  ${Heading3};
  align-self: center;
  padding-top: ${values.large};
`

export const Message = styled.p`
  ${Body};
  align-self: center;
  padding: ${values.small} 0;
  max-width: 500px;
  text-align: center;
`

export const Button = styled(SpecialButtonLink)``

export const FooterContainer = styled.footer`
  background-color: white;
  flex-shrink: 0;
`
